import { fetchData } from "../pages/Utils/Baseurl";

export const getTestCaseStatusMiddleware = async () => {
  return await fetchData("api/testcase_choices/");
};
